type Nazione = "ITALIA"
const NazioneArray = [
  "ITALIA"
];

export {
  Nazione,
  NazioneArray
};
